module.exports = __webpack_public_path__ + "static/img/qi_7.179c5d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qi_7.jpg
// module id = zR1g
// module chunks = 1